import { CompanyReportSectionType } from 'app/area/company-reports-administration/form/metroline/types';
import { filtersHaveChanges } from 'app/area/shared/default-filters/utils/filters-have-changes';
import { selectorId } from 'app/area/shared/selector-id';
import { DefaultContainerProps } from 'app/infrastructure/redux';
import { CompanyReportAdminState } from '../types-store';
import { hasChanges, savedReportsHaveChanges } from './utils/has-changes';

export interface CompanyReportFormSelectorProps {
  id: number;
  favouriteId: number;
  shouldPrompt: boolean;
  section: CompanyReportSectionType;
}

type CompanyReportFormSelectors = { [T in keyof CompanyReportFormSelectorProps]?:
  (state: CompanyReportAdminState, props: DefaultContainerProps) => CompanyReportFormSelectorProps[T] };

export const selectors: CompanyReportFormSelectors = {
  shouldPrompt: ({ form }) =>
    hasChanges(form?.companyReportItem, form?.originalCompanyReportItem) ||
    savedReportsHaveChanges(form?.savedReports, form?.originalSavedReports) ||
    filtersHaveChanges(form?.filters, form?.originalFilters),
  id: (_, { params }) => selectorId(params?.id),
  section: (_, { params }) =>
    params?.section || undefined
};
